import { put, call, select } from 'redux-saga/effects';
import { Types } from './actions';
import ScheduleRepository from '../../../repositories/ScheduleRepository';
import ScheduleDataRepository from '../../../../data/repositories/ScheduleDataRepository';
import constants from '../../../../core/constants';
import IDHelpers from '../../../../core/helpers/IDHelper';
import buildings from '../getExamsUseCase/buildings.json';
import { extractCampusAndSede } from '../getExamsUseCase/saga';

export function FilterAndMap(meetingsWithProfessor: any) {
  return meetingsWithProfessor
    .filter(
      (m: any) =>
        m.instructionMode === constants.INSTRUCTION_MODES.PRESENCIAL ||
        (m.instructionMode === constants.INSTRUCTION_MODES.SEMI_PRESENCIAL &&
          [
            constants.CLASS_TYPE.faceToFaceTheoretical,
            constants.CLASS_TYPE.faceToFacePractical,
            constants.CLASS_TYPE.remoteTheoretical,
            constants.CLASS_TYPE.remotePractical
          ].includes(m.classType)) ||
        (m.instructionMode === constants.INSTRUCTION_MODES.REMOTO &&
          [
            constants.CLASS_TYPE.faceToFaceTheoretical,
            constants.CLASS_TYPE.faceToFacePractical,
            constants.CLASS_TYPE.remoteTheoretical,
            constants.CLASS_TYPE.remotePractical
          ].includes(m.classType))
    )
    .map((m: any) => ({
      name: m.name,
      start: m.start,
      end: m.end,
      professor: m.professor,
      type: [
        constants.CLASS_TYPE.faceToFacePractical,
        constants.CLASS_TYPE.faceToFaceTheoretical
      ].includes(m.classType)
        ? constants.CARD_TYPES.CURSO_PRESENCIAL
        : constants.CARD_TYPES.CURSO_REMOTO,
      idZoom: '',
      isReprog: m.isReprog,
      eventId: m.eventId,
      instructionMode: m.instructionMode,
      classType: m.classType,
      linkZoom: m.class.linkZoom,
      isClass: m.class.isClass,
      isHybrid: m.class.isHybrid,
      id: m.id,
      location: m.location,
      descAmb: m.descAmb,
      linkCourseClass: m.linkCourseClass
    }));
}

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.GET_SCHEDULE_ONLY_REQUEST });
    const { startDate } = action;
    // Leer periodos
    const periods = yield select((state) => state.getPeriods?.data);
    // consultar horario de graphql v2
    const scheduleRepository: ScheduleRepository = new ScheduleDataRepository();
    const scheduleResponse = yield call(
      scheduleRepository.getSchedule,
      startDate, // action.startDate,
      periods.map((p: any) => p.period)
    );
    if (!scheduleResponse) {
      yield put({
        type: Types.GET_SCHEDULE_ONLY_FAILURE,
        error: 'Ocurrió un error al leer el horario.'
      });
      return;
    }

    let dataItems: any[] = [];
    (scheduleResponse as any[]).forEach((day: any) => {
      if (day.items.length > 0) {
        dataItems = dataItems.concat([...day.items]);
      }
    });
    const meetings: any[] = dataItems;
    const meetingsWithProfessor = meetings.map((m: any) => {
      const buildingInformation = buildings.find(
        (building) => building.id === m.class.location.building.id
      );

      const { campus, sede } = extractCampusAndSede(
        buildingInformation?.description ?? ''
      );
      return {
        ...m,
        eventId: IDHelpers.generateID(),
        professor: m.class.professors, // null
        instructionMode: m.class.instructionMode,
        classType: m.class.classType,

        name: m.name,
        start: m.class.start,
        end: m.class.end,
        type: [
          constants.CLASS_TYPE.faceToFacePractical,
          constants.CLASS_TYPE.faceToFaceTheoretical
        ].includes(m.class.classType)
          ? constants.CARD_TYPES.CURSO_PRESENCIAL
          : constants.CARD_TYPES.CURSO_REMOTO,
        idZoom: '',
        isReprog: m.isRescheduled,
        linkZoom: m.linkZoom,
        isClass: m.class.isClass,
        isHybrid: m.class.isHybrid,
        id: m.class.id,
        location: {
          classRoom: m.class.location.classRoom,
          building: {
            address: buildingInformation?.address ?? '-',
            campus: campus ?? '-',
            sede: sede ?? '-',
            description: buildingInformation?.description?.toLowerCase() ?? '-',
            coordinates: buildingInformation?.coordinates
          }
        },
        descAmb: m.class.descAmb,
        hours: m.class.hours,
        linkCourseClass: m.class.linkCourseClass
      };
    });

    const nmeetingsF = FilterAndMap(meetingsWithProfessor);

    const isCGTMode = yield select(
      (state: any) => state.profile?.data?.academic.isCGT
    ) || null;

    const virtualMeetings = meetingsWithProfessor.filter(
      (meet: any) =>
        (meet.instructionMode === 'SP' &&
          isCGTMode &&
          [
            constants.CLASS_TYPE.virtualPractical,
            constants.CLASS_TYPE.virtualTheoretical
          ].includes(meet.classType)) ||
        meet.instructionMode === 'VT' ||
        [
          constants.CLASS_TYPE.virtualPractical,
          constants.CLASS_TYPE.virtualTheoretical
        ].includes(meet.classType)
    );
    const isClass = virtualMeetings.some((row) => row.isClass === true);
    const data = {
      meetings: nmeetingsF,
      virtualMeetings,
      isClassFlag: isClass
    };

    yield put({ type: Types.GET_SCHEDULE_ONLY_SUCCESS, data });
  } catch (error) {
    yield put({
      type: Types.GET_SCHEDULE_ONLY_FAILURE,
      error: 'Ocurrió un error al leer el horario - saga.'
    });
  }
}
